import { type ConditionSettings, ConditionType } from '../../../api/types';

const prepareSubmissionConditionSettings = (input?: ConditionSettings[]) =>
    input?.map(conditionSetting => {
        if (conditionSetting.type === ConditionType.Or || conditionSetting.type === ConditionType.And) {
            return {
                ...conditionSetting,
                logicConditionSettings: {
                    ...conditionSetting.logicConditionSettings,
                    children: prepareSubmissionConditionSettings(conditionSetting.logicConditionSettings?.children),
                },
            };
        }

        if (conditionSetting.type === ConditionType.IsLocation) {
            return {
                ...conditionSetting,
                locationConditionSettings: {
                    ...conditionSetting.locationConditionSettings,
                    locationId: conditionSetting.locationConditionSettings?.locationId,
                    isHomeDelivery: conditionSetting.locationConditionSettings?.isHomeDelivery ?? false,
                },
            };
        }

        return conditionSetting;
    });

export default prepareSubmissionConditionSettings;
